export default __webpack_public_path__ + "static/media/discover.450aa8f9.svg";